import { useForm } from "react-hook-form";
import { useState, useEffect, useRef, useMemo } from "react";
import Modal from "./Modal";
import ModalRemove from "./ModalRemove";
import { useDispatch, useSelector } from "react-redux";
import {
  ObtenerTodos,
  Actualizar,
  Eliminar,
  Insertar,
} from "../../redux/lugaresSlice";
import WindowDimension from "../../Hooks/WindowDimension";
import Required from "../../Components/Required";
import useSubmit from "../../Hooks/useSubmit";
import { OrderTable } from "../../Components/OrderTable";
import { getAdminPlacesPage } from "../../Api/content";
import { useLocale } from "../../i18n/localeContext";
import { Skeleton } from "antd";
import { StrapiError } from '../../Inicio/Pages/StrapiError';

import { useValidation } from "../../Hooks/useValidation";
function Lugares(props) {
  const { validation } = useValidation();
  const { locale } = useLocale();
  const [adminPlacesPage, setAdminPlacesPage] = useState(null);
  const [isLoadingContent, setIsLoadingContent] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [tituloModal, setTituloModal] = useState("Agregar");
  const [removeState, changeRemoveState] = useState(false);
  const [itemSelected, setItemSelected] = useState({});
  const { width } = WindowDimension();

  const dispatch = useDispatch();
  let busqueda = useRef();

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
  } = useForm();

  const columns = useMemo(() => {
    const table = adminPlacesPage?.place_table    ?? [];
    return [
      { label: table[0]?.label || "Código", accessor: "lugarId", sortable: true },
      { label: table[1]?.label || "Lugar", accessor: "lugarNombre", sortable: true },
      { label: table[2]?.label || "Acción", accessor: "action", sortable: false },
    ];
  }, [adminPlacesPage]);

  const { lugares } = useSelector((state) => state.lugares);
  const { submitAction } = useSubmit();

  const showModalEdit = (item) => {
    reset(item);
    setTituloModal(adminPlacesPage?.subtitleT || "Editar");
    setShowModal(true);
  };

  const closeModalEdit = () => {
    reset({ lugarId: 0, lugarNombre: "" });
    setShowModal(false);
  };

  const showRemoveModalEdit = (item) => {
    setItemSelected(item);
    changeRemoveState(true);
  };

  const closeRemoveModalEdit = () => {
    setItemSelected({});
    changeRemoveState(false);
  };

  const cargarDatos = () => {
    dispatch(ObtenerTodos());
  };
  const cargarLugaresPorCaracter = () => {
    dispatch(ObtenerTodos(busqueda.current.value));
  };

  const eliminar = async () => {
    submitAction(Eliminar, itemSelected.lugarId, () => {
      closeRemoveModalEdit();
      cargarDatos();
    });
  };

  const onSubmit = async (data) => {
    submitAction(data.lugarId > 0 ? Actualizar : Insertar, data, () => {
      closeModalEdit();
      cargarDatos();
    });
  };

  useEffect(() => {
    cargarDatos();
  }, [dispatch]);

  useEffect(() => {
    let cancel = false;
    setIsLoadingContent(true);
    getAdminPlacesPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          setAdminPlacesPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => { 
        if (!cancel) {
          setAdminPlacesPage(null);
          setIsLoadingContent(false);
        }
      });
    return () => { cancel = true };
  }, [locale])

  if (isLoadingContent) {
    return (
      <div className="main-admin">
        <div className="main-admin-bar">
          <div className="header-admin-bar-items">
            <Skeleton.Button style={{ width: 40, height: 40 }} active />
            <Skeleton.Input style={{ width: 200, height: 30 }} active />
          </div>
          <div className="header-admin-bar-items ml-auto">
            <Skeleton.Input style={{ width: 200, height: 40 }} active />
          </div>
        </div>
        <div className="table-container">
          <Skeleton.Input style={{ width: '100%', height: 400, minWidth: '800px' }} active />
        </div>
      </div>
    );
  }

  return (
    <div className="main-admin">
      <div className="main-admin-bar">
        <div className="header-admin-bar-items">
          <button
            className="main-admin-button"
            onClick={() => {
              setShowModal(true);
              setTituloModal(adminPlacesPage?.subtitleO || "Agregar");
              setValue("lugarNombre", "");
              reset();
            }}
          >
            +
          </button>
          <h2>{adminPlacesPage?.title || "Lugares"}</h2>
        </div>

        <div className="header-admin-bar-items ml-auto">
          <label hidden>Búsqueda</label>
          <input
            type="search"
            className="form-control"
            ref={busqueda}
            placeholder={adminPlacesPage?.search_input || "Búsqueda"}
            onInput={cargarLugaresPorCaracter}
          />
        </div>
      </div>

      <div className="table-container">
        {lugares?.length > 0 ? (
          <OrderTable
            {...{ columns }}
            data={lugares}
            clase="table-adm"
            actions={[
              {
                icon: "",
                clase: "text-primary",
                style: { display: "contents" },
                event: (item) => showModalEdit(item),
              },
              {
                icon: "",
                clase: "delete",
                style: { display: "contents" },
                event: (item) => showRemoveModalEdit(item),
              },
            ]}
          />
        ) : (
          <div className="no-results-container">
            <img src={props.img} alt="Imagen sin resultados" />
            <h1>{props.noResultMessage}</h1>
          </div>
        )}
      </div>

      <Modal
        estado={showModal}
        cambiarEstado={closeModalEdit}
        titulo={tituloModal}
        clase={`${width < 576 ? "full-width" : "small"}`}
        buttonGroup={
          <>
            <button
              type="submit"
              className="button-text"
              onClick={handleSubmit(onSubmit)}
            >
              {adminPlacesPage?.save_button || "Guardar"}
            </button>
          </>
        }
      >
        <form>
          <div className="form-group">
            <label>{adminPlacesPage?.place_name || "Nombre del lugar"}</label>
            <Required />
            <input
              className="form-control"
              name="lugarNombre"
              {...register("lugarNombre", { required: validation?.required_field || "Campo requerido" })}
            />
            {errors.lugarNombre && (
              <p className="error">{errors.lugarNombre.message}</p>
            )}
          </div>
        </form>
      </Modal>

      <ModalRemove
        estado={removeState}
        closeModalHandled={closeRemoveModalEdit}
        title={adminPlacesPage?.subtitleTR || "Eliminar plantillla"}
        message={adminPlacesPage?.question || "¿Seguro que desea eliminar el siguiente registro?"}
        item={itemSelected.lugarNombre}
        btnGroup={
          <>
            <button className="button-text text-red" onClick={eliminar}>
              {adminPlacesPage?.confirm_button || "Confirmar"}
            </button>
            <button
              className="button-text text-grey"
              onClick={() => {
                closeRemoveModalEdit(false);
              }}
            >
              {adminPlacesPage?.cancel_button || "Cancelar"}
            </button>
          </>
        }
      />
    </div>
  );
}

export default Lugares;
